import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetItemLocationStockQueryVariables = Types.Exact<{
  item_location_id: Types.Scalars['ID'];
}>;


export type GetItemLocationStockQuery = { __typename?: 'Query', getItemLocationStock: { __typename?: 'ItemLocationStock', container_type_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, container_station_amounts: Array<{ __typename?: 'ContainerStationAmount', image_url?: string | null, amount: number, amount_sealed: number, counted: number, countLater: number, empty: number, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, image_url?: string | null, archived: boolean, category: Types.ItemTypeCategory, epc_asset_id: number } }>, asset_amounts: Array<{ __typename?: 'AssetAmount', amount: number, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, image_url?: string | null, archived: boolean, category: Types.ItemTypeCategory, epc_asset_id: number } }> } };


export const GetItemLocationStockDocument = gql`
    query GetItemLocationStock($item_location_id: ID!) {
  getItemLocationStock(item_location_id: $item_location_id) {
    container_type_amounts {
      container_type_id
      container_type_name
      container_type_image
      amount
      amount_sealed
    }
    container_station_amounts {
      item_type {
        id
        name
        color_hex_code
        image_url
        archived
        category
        epc_asset_id
      }
      image_url
      amount
      amount_sealed
      counted
      countLater
      empty
    }
    asset_amounts {
      item_type {
        id
        name
        color_hex_code
        image_url
        archived
        category
        epc_asset_id
      }
      amount
    }
  }
}
    `;

/**
 * __useGetItemLocationStockQuery__
 *
 * To run a query within a React component, call `useGetItemLocationStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemLocationStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemLocationStockQuery({
 *   variables: {
 *      item_location_id: // value for 'item_location_id'
 *   },
 * });
 */
export function useGetItemLocationStockQuery(baseOptions: Apollo.QueryHookOptions<GetItemLocationStockQuery, GetItemLocationStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemLocationStockQuery, GetItemLocationStockQueryVariables>(GetItemLocationStockDocument, options);
      }
export function useGetItemLocationStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemLocationStockQuery, GetItemLocationStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemLocationStockQuery, GetItemLocationStockQueryVariables>(GetItemLocationStockDocument, options);
        }
export type GetItemLocationStockQueryHookResult = ReturnType<typeof useGetItemLocationStockQuery>;
export type GetItemLocationStockLazyQueryHookResult = ReturnType<typeof useGetItemLocationStockLazyQuery>;
export type GetItemLocationStockQueryResult = Apollo.QueryResult<GetItemLocationStockQuery, GetItemLocationStockQueryVariables>;